import { render } from "./SwitchSimple.vue?vue&type=template&id=b1255b30&scoped=true"
import script from "./SwitchSimple.vue?vue&type=script&lang=js"
export * from "./SwitchSimple.vue?vue&type=script&lang=js"

import "./SwitchSimple.vue?vue&type=style&index=0&id=b1255b30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1255b30"]])

export default __exports__